import {
    useTheme 
} from '@mui/material';
import {
    TypographyWeights 
} from '../../../figmaTheme';

type Props = {
    currentValue: number,
    targetValue: number,
    type: 'drinks' | 'days';
};

export const Graph = ({
    currentValue, targetValue, type 
}: Props): JSX.Element => {
    const theme = useTheme();
    return (
        <>
            {type === 'drinks' && (
                <svg
                    width="186"
                    height="128"
                    viewBox="0 0 186 128"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 0.5L184.546 123.855C186.188 124.952 185.415 127.512 183.44 127.517L16.0421 127.958C7.18913 127.981 0 120.811 0 111.958V0.5Z"
                        fill="url(#paint0_linear_2489_95158)"
                    />
                    <line
                        x1="25"
                        y1="16"
                        x2="25"
                        y2="80"
                        stroke={theme.palette.neutral['300']}
                        strokeWidth={1}
                        strokeDasharray={2}
                    />
                    <line
                        x1="165"
                        y1="110"
                        x2="165"
                        y2="16"
                        stroke={theme.palette.neutral['300']}
                        strokeWidth={1}
                        strokeDasharray={2}
                    />
                    <circle
                        cx="25"
                        cy="16"
                        r="6"
                        fill={theme.palette.tertiary.main}
                        strokeWidth={1}
                        stroke={theme.palette.white}
                    />
                    <circle
                        cx="165"
                        cy="110"
                        r="6"
                        fill={theme.palette.tertiary.main}
                        strokeWidth={1}
                        stroke={theme.palette.white}
                    />
                    <text
                        fontFamily={'Poppins'}
                        x="25"
                        y="95"
                        fontSize="10"
                        fontWeight={TypographyWeights.SEMI_BOLD}
                        fill={theme.palette.neutral['400']}
                    >
                        Baseline:
                    </text>
                    <text
                        fontFamily={'Poppins'}
                        x="25"
                        y="110"
                        fontSize="10"
                        fill={theme.palette.neutral['400']}
                    >
                        {`${currentValue} Weekly Drinks`}
                    </text>
                    <text
                        fontFamily={'Poppins'}
                        x="95"
                        y="24"
                        fontSize="10"
                        fontWeight={TypographyWeights.SEMI_BOLD}
                        fill={theme.palette.neutral['400']}
                    >
                        In one year:
                    </text>
                    <text
                        fontFamily={'Poppins'}
                        x={targetValue >= 10 ? 70 : 77}
                        y="38"
                        fontSize="10"
                        fill={theme.palette.neutral['400']}
                    >
                        {`${targetValue} Weekly Drinks`}
                    </text>
                    <defs>
                        <linearGradient
                            id="paint0_linear_2489_95158"
                            x1="95"
                            y1="14"
                            x2="95"
                            y2="142"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop
                                stopColor={theme.palette.tertiary.main}
                                stopOpacity="0.6"
                            />
                            <stop
                                offset="0.48"
                                stopColor={theme.palette.tertiary.main}
                                stopOpacity="0.25"
                            />
                            <stop
                                offset="1"
                                stopColor={theme.palette.tertiary.main}
                                stopOpacity="0"
                            />
                        </linearGradient>
                    </defs>
                </svg>
            )}
            {type === 'days' && (
                <svg
                    width="190"
                    height="136"
                    viewBox="0 0 190 109"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M190 0L0 108.5L173.958 108.958C182.811 108.981 190 101.811 190 92.9578V0Z"
                        fill="url(#paint0_linear_2489_95169)"
                    />
                    <line
                        x1="165"
                        y1="16"
                        x2="165"
                        y2="100"
                        stroke={theme.palette.neutral['300']}
                        strokeWidth={1}
                        strokeDasharray={2}
                    />
                    <line
                        x1="25"
                        y1="110"
                        x2="25"
                        y2="16"
                        stroke={theme.palette.neutral['300']}
                        strokeWidth={1}
                        strokeDasharray={2}
                    />
                    <circle
                        cx="165"
                        cy="16"
                        r="6"
                        fill={theme.palette.tertiary.main}
                        strokeWidth={1}
                        stroke={theme.palette.white}
                    />
                    <circle
                        cx="25"
                        cy="110"
                        r="6"
                        fill={theme.palette.tertiary.main}
                        strokeWidth={1}
                        stroke={theme.palette.white}
                    />
                    <text
                        fontFamily={'Poppins'}
                        x="35"
                        y="24"
                        fontSize="10"
                        fontWeight={TypographyWeights.SEMI_BOLD}
                        fill={theme.palette.neutral['400']}
                    >
                        Baseline:
                    </text>
                    <text
                        fontFamily={'Poppins'}
                        x="35"
                        y="38"
                        fontSize="10"
                        fill={theme.palette.neutral['400']}
                    >
                        {`${currentValue} per week`}
                    </text>
                    <text
                        fontFamily={'Poppins'}
                        x="95"
                        y="95"
                        fontSize="10"
                        fontWeight={TypographyWeights.SEMI_BOLD}
                        fill={theme.palette.neutral['400']}
                    >
                        In one year:
                    </text>
                    <text
                        x={targetValue >= 10 ? 95 : 104}
                        y="110"
                        fontSize="10"
                        fill={theme.palette.neutral['400']}
                    >
                        {`${targetValue} per week`}
                    </text>
                    <defs>
                        <linearGradient
                            id="paint0_linear_2489_95169"
                            x1="95"
                            y1="-5"
                            x2="95"
                            y2="123"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop
                                stopColor={theme.palette.tertiary.main}
                                stopOpacity="0.6"
                            />
                            <stop
                                offset="0.48"
                                stopColor={theme.palette.tertiary.main}
                                stopOpacity="0.25"
                            />
                            <stop
                                offset="1"
                                stopColor={theme.palette.tertiary.main}
                                stopOpacity="0"
                            />
                        </linearGradient>
                    </defs>
                </svg>
            )}
        </>
    );
};

export default Graph;
